import { AxiosInstance } from "axios";

import { FeatureFlagService } from "../interfaces/FeatureFlag";


export const FeatureFlagServiceImpl = (client: AxiosInstance): FeatureFlagService => {
    const getFeatureFlags = async () => {
        const res = await client.get("/api/feature_flags");

        if (res.status !== 200) {
            console.error("Could not fetch feature flags");

            return [];
        }

        return res.data.flags;
    };

    return { getFeatureFlags };
};
